export { default } from "-!./Settings.ts?vue&type=script&lang=ts&external"; export * from "-!./Settings.ts?vue&type=script&lang=ts&external"